export const ANALYTICS_COLORS = ['#2563eb', '#16a34a', '#f59e0b', '#dc2626', '#0891b2', '#9333ea'];

export function formatNumber(value: number) {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value || 0);
}

export function formatPercent(value: number | null) {
  if (value === null) return '--';
  return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value)}%`;
}

export function formatSignedNumber(value: number) {
  const formatted = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Math.abs(value));
  if (value > 0) return `+${formatted}`;
  if (value < 0) return `-${formatted}`;
  return formatted;
}

export function formatSignedPercent(value: number | null) {
  if (value === null) return '--';
  const formatted = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(Math.abs(value));
  if (value > 0) return `+${formatted}%`;
  if (value < 0) return `-${formatted}%`;
  return `${formatted}%`;
}

export function formatDeltaText(
  delta: { absoluteChange: number; percentChange: number | null; hasPriorBaseline: boolean },
  labels: { newLabel: string; noBaselineLabel: string },
) {
  if (!delta.hasPriorBaseline) {
    if (delta.absoluteChange > 0) {
      return `${formatSignedNumber(delta.absoluteChange)} (${labels.newLabel})`;
    }

    return `${formatSignedNumber(delta.absoluteChange)} (${labels.noBaselineLabel})`;
  }

  return `${formatSignedNumber(delta.absoluteChange)} (${formatSignedPercent(delta.percentChange)})`;
}

export function formatUtcRange(start?: string | null, end?: string | null) {
  if (!start || !end) return '';

  const formatter = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short',
  });

  return `${formatter.format(new Date(start))} - ${formatter.format(new Date(end))}`;
}
